import React from "react";
import { Button, Card, CardActions, CardContent, Typography } from "@mui/material";
import { Dialog } from "@mui/material";
import { red } from "../../shared/colours";

const CyberRiskRecommendedModal = (props) => {
	
	const handleClose = () => {
		props.onClose()
	};
	
	let headerColor = red;
	
	return (
		<Dialog
			open={props.recommendation? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<Card
				sx={{
					flexGrow: 1,
					border: "2px",
					position: "relative",
					height: "100%",
					margin: "1em",
				}}
			> 
					{(props.recommendation)?
					<CardContent>
							<Typography sx={{
								background: headerColor,
								borderRadius: 1,
								padding: "0.5em",
								textAlign: "center",
								fontWeight: "bold",
								color: "#fff"
							}}>
								Recommendation
							</Typography>
							<Typography variant="h6" sx={{
								marginTop: "0.5em",
								marginBottom: "0.25em"
							}}>
								{props.recommendation.title}
							</Typography>
							<Typography sx={{ marginTop: "0.5em" }}>
								{props.recommendation.description}
							</Typography>
							<Typography sx={{ marginTop: "1em", fontWeight: "bold" }}>
								How do I resolve this issue?
							</Typography>
							<Typography sx={{ marginTop: "1em" }}>
								{props.recommendation.action}
							</Typography>
					</CardContent>
					: <CardContent/> }
				<CardActions>
					<Button onClick={handleClose} size="small">Close</Button>
				</CardActions>
			</Card>
		</Dialog>
	);
};

export default CyberRiskRecommendedModal;